
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { TeMeasurement } from '../../backend/backendapi';
import { formatDateTimeForInput, parseDateTimeFromInput } from '../../../util';

@Component
export default class TeMeasurementRowSeparateTesterEditor extends Vue {
  @Prop({ required: true })
  readonly measurement!: TeMeasurement;

  get testDate(): string | null {
    if (!this.measurement.testDate) {
      return null;
    } else {
      return formatDateTimeForInput(this.measurement.testDate);
    }
  }

  set testDate(testDate: string | null) {
    if (!this.measurement.testDate) {
      this.$set(this.measurement, 'testDate', null);
    }
    this.measurement.testDate = !testDate ? undefined : parseDateTimeFromInput(testDate);
  }
}
